export function signInRequest(username, password) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { username, password },
  };
}

export function signInSuccess(token) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}

export function signOutRequest() {
  return {
    type: '@auth/SIGN_OUT_REQUEST',
  };
}

export function signOutSuccess() {
  return {
    type: '@auth/SIGN_OUT_SUCCESS',
  };
}

export function tokenExpired() {
  return {
    type: '@auth/TOKEN_EXPIRED',
  };
}

export function rememberCredentials(username, password, checked) {
  return {
    type: '@auth/REMEMBER_CREDENTIALS',
    payload: { username, password, checked },
  };
}

export function rememberCnpj(cnpj) {
  return {
    type: '@auth/REMEMBER_CNPJ',
    payload: { cnpj },
  };
}
